import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import IconNav from "./IconNav";
import IconTabContent from "./IconTabContent";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { IconTabsTitle } from "../../../../Constants/Constants";
import { IconTabsSubTitle } from "../../../../Data/UiKits/Tabs";

const IconTabs = () => {
  const [basicTab, setBasicTab] = useState("1");
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={IconTabsTitle} span={IconTabsSubTitle} />
        <CardBody>
          <IconNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <IconTabContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default IconTabs;
